module.exports = __webpack_public_path__ + "static/media/pet-sky-blue-icon.c1c118ee.svg";